<template>
  <div class="basket-group-body">
    <div class="basket-text">
      <span>{{ basketItemGroup.quantity }}</span>
      x
      <span>
        <template v-if="basketItemGroup.priceBand">{{ basketItemGroup.priceBand }} /</template>
        {{ basketItemGroup.concession }}
      </span>
      <div>{{ itemGroupDescription }}</div>
    </div>
    <div class="basket-cost">
      <div class="basket-price">
        <span class="basket-amount">£{{ basketItemGroup.price.toFixed(2) }}</span>
      </div>
      <div class="basket-fees">
        + booking fee
        <span class="basket-amount">£{{ basketItemGroup.fees.toFixed(2) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    basketItemGroup: { type: Object, default: null },
    productType: { type: String, default: null }
  },
  computed: {
    itemGroupDescription() {
      var description = '';
      switch (this.productType) {
        case 'Stock':
        case 'Untracked':
        case 'GA':
          description = this.basketItemGroup.items[0].description;
          break;
        case 'Seated':
          description = 'Seats: ';
          this.basketItemGroup.items.forEach(function(item) {
            description = description + item.description + ', ';
          });
          if (description.endsWith(', ')) {
            description = description.substring(0, description.length - 2);
          }
          break;
      }
      return description;
    }
  }
};
</script>
